export const AVAILABLE_FEATURES_LIST = {
  newSuperNinjaPlans: true,
  newBusinessMaxPlan: true,
  ABtestPaymentPage: true,
};
